import React from "react";
import MobilePlayerControl from "./MobilePlayerControl";
import PropTypes from "prop-types";


class MobileInteractivePlayerContainer extends React.Component {
  static defaultProps = {
    updatePlaceholder: () => {}
  }

  state = {
    poppedOut: false
  }

  handleContainerClick = (e) => {
    if (this.state.poppedOut) {
      e.stopPropagation();
      e.preventDefault();
      e.stopImmediatePropagation();
      const { onMobilePopOutPress } = this.props;
      onMobilePopOutPress && onMobilePopOutPress();
    }
  }

  componentDidMount() {
    this.playerControls.style.display = "none";
    this.container.addEventListener('touchend', this.handleContainerClick, true);
  }

  componentWillUnmount() {
    this.container.removeEventListener('click', this.handleContainerClick);
  }

  findOoyalaPlayerElement = () => {
    return this.container.getElementsByClassName('oo-player')[0];
  }

  onPlayerReady = () => {
    this.playerSkin = this.findOoyalaPlayerElement();
    this.videoElement = this.container.getElementsByTagName('video')[0];
  }

  getPlayerSkin = () => {
    if (!this.container) {
      return undefined;
    }

    if (!this.playerSkin) {
      this.playerSkin = this.findOoyalaPlayerElement();
    }

    return this.playerSkin;
  }

  mobilePlayerTransitionPositionStyle = () => {
    const showPlaceholder = this.state.poppedOut;
    const style = {
      zIndex: 1000,
    };

    style.minWidth = 320;

    if (showPlaceholder) {
      style.position = 'fixed';
      style.transform = 'scale(0.75)';
    }


    style.left = 10;
    style.bottom = 55;

    return style;
  }

  bouncePlayerIn = () => {
    const playerSkin = this.getPlayerSkin();

    if (!playerSkin) {
      return Promise.resolve();
    }

    return new Promise((resolve) => {
      playerSkin.classList.add('bounceIn');
      const handler = () => {
        playerSkin.classList.remove('bounceIn');
        playerSkin.removeEventListener('animationend', handler);
        resolve();
      }
      playerSkin.addEventListener('animationend', handler);
    })
  }

  bouncePlayerOut = () => {
    const playerSkin = this.getPlayerSkin();

    if (!playerSkin) {
      return Promise.resolve();
    }

    return new Promise((resolve) => {
      playerSkin.classList.add('bounceOut');
      const handler = () => {
        playerSkin.classList.remove('bounceOut');
        playerSkin.removeEventListener('animationend', handler);
        resolve();
      }
      playerSkin.addEventListener('animationend', handler);
    })
  }

  slideControlsIn = () => {
    if (!this.playerControls) {
      return Promise.resolve();
    }

    return new Promise((resolve) => {
      this.playerControls.style.display = "unset";
      this.playerControls.classList.add('slideIn');
      const handler = () => {
        this.playerControls.classList.remove('slideIn');
        this.playerSkin.removeEventListener('animationend', handler);
        resolve();
      }
      this.playerControls.addEventListener('animationend', handler);
    });
  }

  slideControlsOut = () => {
    if (!this.playerControls) {
      return Promise.resolve();
    }

    return new Promise((resolve) => {
      this.playerControls.classList.add('slideOut');
      const handler = () => {
        this.playerControls.style.display = "none";
        this.playerControls.classList.remove('slideOut');
        this.playerControls.removeEventListener('animationend', handler);
        resolve();
      }
      this.playerControls.addEventListener('animationend', handler);
    });
  }

  popOut() {
    this.setState({
      poppedOut: true
    })
    this.props.updatePlaceholder(true);
    return new Promise(resolve => {
      this.bouncePlayerIn().then(this.slideControlsIn).then(() => {
        resolve();
      });
    });
  }

  popIn() {
    return new Promise(resolve => {
      this.slideControlsOut().then(this.bouncePlayerOut).then(() => {
        this.setState({
          poppedOut: false
        });
        this.props.updatePlaceholder(false);
        resolve();
      });
    });
  }

  setPopOutState(shouldPopOut) {
    if (shouldPopOut && !this.state.poppedOut) {
      return this.popOut();
    }

    if (!shouldPopOut && this.state.poppedOut) {
      return this.popIn();
    }

    return Promise.resolve();
  }

  setContainerReference = (ref) => {
    this.container = ref;
  }

  setPlayerControlsReference = (ref) => {
    this.playerControls = ref;
  }

  render() {
    return (
      <div className="spl-interactive-video-player">
        <div
          ref={this.setContainerReference}
          className={`transitionPosition ${this.state.poppedOut ? 'poppedOut' : ''}`}
          style={this.mobilePlayerTransitionPositionStyle()}
        >
          {this.props.children}
        </div>
        <div
          ref={this.setPlayerControlsReference}
          style={{
            position: 'fixed',
            bottom: 54,
            left: 249,
            right: 10,
            height: 135,
            borderRadius: '0 4px 4px 0',
            boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.25)',
            backgroundColor: '#0b2451',
            color: 'white',
            zIndex: 1000
          }}
        >
          <img
            onClick={this.props.dismissPlayer}
            className="dismiss-button-mobile"
            src="/img/icons/ooyala/close-icon.svg"
          />
          <MobilePlayerControl player={this.props.player} />
        </div>
      </div>
    )
  }
}

MobileInteractivePlayerContainer.propTypes = {
  player: PropTypes.shape({
    play: PropTypes.func,
    pause: PropTypes.func
  }),
  children: PropTypes.any,
  updatePlaceholder: PropTypes.func,
  dismissPlayer: PropTypes.func,
  onMobilePopOutPress: PropTypes.func
}

export default MobileInteractivePlayerContainer;



// WEBPACK FOOTER //
// ./modules/Ooyala/component/MobileInteractivePlayerContainer.js